import { api } from "../api";

export function GetAllGenders() {
    return api.get('api/gender/GetAll')
}